import script from "./TimerWithSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./TimerWithSpinner.vue?vue&type=script&setup=true&lang=js"

import "./TimerWithSpinner.vue?vue&type=style&index=0&id=59d898b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d898b4"]])

export default __exports__